import type { EventParticipantRsvp } from 'models';
import { useCallback } from 'react';
import { message } from 'ui';
import { useUpdateNodeEventUserStatusMutation } from '../queries';
import type { EventData } from '../types';
import { isAfterJoinPeriod } from '../utils';

export const useHandleRsvpStatus = ({ data }: { data: EventData }) => {
  const { isPending: isAccepting, mutate: acceptEvent } = useUpdateNodeEventUserStatusMutation();
  const { isPending: isRejecting, mutate: rejectEvent } = useUpdateNodeEventUserStatusMutation();

  const isPastEvent = isAfterJoinPeriod(data.endTime);
  const isOpenToResponse = !isPastEvent;

  const handleRsvpStatus = useCallback(
    (action: EventParticipantRsvp) => {
      switch (action) {
        case 'going':
          if (isOpenToResponse) {
            acceptEvent({ id: data.id, statusToApply: action });
          } else {
            message.warning('This event has started already');
          }
          break;
        case 'not_going':
          if (isOpenToResponse) {
            rejectEvent({ id: data.id, statusToApply: action });
          } else {
            message.warning('This event has started already');
          }
          break;

        case 'pending':
          console.warn('Pending RSVP status is implemented');
          break;
      }
    },
    [isOpenToResponse, data, acceptEvent, rejectEvent],
  );

  return {
    handleRsvpStatus,
    isAccepting,
    isRejecting,
  };
};
